var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { staticClass: "settings-page" }, [
    _c(
      "div",
      { staticClass: "settings-card" },
      [
        _c("h5", [_vm._v("Address Verification")]),
        _c("p", [
          _vm._v(
            "\n      Checks student addresses with Google as they are entered, on class saves and roster imports,\n      and when an admin approves a class. Results are informational: they show next to each\n      address, in the approval warning and in the Address Validation report, and never stop a\n      class from being saved, approved, processed or paid for.\n    "
          )
        ]),
        _c("p", [
          _vm._v(
            "\n      Turning this off stops every request to Google's Address Validation API (which is billed per\n      request). Results already recorded are kept and still appear in the report.\n    "
          )
        ]),
        _c("q-toggle", {
          attrs: {
            value: _vm.addressVerificationEnabled,
            disable: !_vm.loaded || _vm.saving || !_vm.$p(["ADMIN"]),
            label: "Verify student addresses"
          },
          on: { input: _vm.toggleAddressVerification }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }